export const radio = (theme) => {
    return {
        icon: {
            default: {
                backgroundColor: theme.colors?.foreground?.inverse,
            },
            disabled: {
                backgroundColor: theme.colors?.foreground?.disabled,
            },
        },
        regular: {
            default: {
                border: `1px solid ${theme.colors?.border?.strong}`,
                backgroundColor: theme.colors?.component?.default,
            },
            checked: {
                border: 'none',
                backgroundColor: theme.colors?.component?.brand?.default,
            },
        },
        hover: {
            default: {
                border: `1px solid ${theme.colors?.border?.strong}`,
                backgroundColor: theme.colors?.component?.hover,
            },
            checked: {
                border: 'none',
                backgroundColor: theme.colors?.component?.brand?.hover,
            },
        },
        active: {
            default: {
                border: `1px solid ${theme.colors?.border?.strong}`,
                backgroundColor: theme.colors?.component?.active,
            },
            checked: {
                border: 'none',
                backgroundColor: theme.colors?.component?.brand?.active,
            },
        },
        focus: {
            default: {
                border: `2px solid ${theme.colors?.border?.focus}`,
                backgroundColor: theme.colors?.component?.default,
            },
            checked: {
                backgroundColor: theme.colors?.component?.brand?.default,
            },
        },
        disabled: {
            border: `1px solid ${theme.colors?.border?.disabled}`,
            backgroundColor: theme.colors?.component?.disabled,
        },
    };
};
//# sourceMappingURL=radio.js.map